/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totp_Unenroll_Confirm_TitleInputs */

const fr_totp_unenroll_confirm_title = /** @type {(inputs: Totp_Unenroll_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactiver l'authentification à deux facteurs`)
};

/**

* @param {Totp_Unenroll_Confirm_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const totp_unenroll_confirm_title = /** @type {((inputs?: Totp_Unenroll_Confirm_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totp_Unenroll_Confirm_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_totp_unenroll_confirm_title(inputs)
});